module.exports = __webpack_public_path__ + "img/audio-1.39e5b626.jpg";